import React from 'react'
import TestGround from './TestGround'

const TestIndex = () => {
    return (
        <div>
            TestIndex
            <TestGround />
        </div>
    )
}

export default TestIndex